"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionFromObj = void 0;
var pageareas_1 = require("./../v0001/pageareas");
var utils_1 = require("../../utils");
function sectionFromObj(obj) {
    return {
        pageIdxs: obj.pageIdxs || [],
        startSec: obj.start ? utils_1.stringToSecs(obj.start) : obj.startSec,
        endSec: obj.end ? utils_1.stringToSecs(obj.end) : obj.endSec,
        pageAreas: (obj.pageAreas || []).map(function (pa) { return pageareas_1.pageAreasFromObj(pa); })
    };
}
exports.sectionFromObj = sectionFromObj;
